import { render, staticRenderFns } from "./rectangles.vue?vue&type=template&id=7c12b098"
import script from "./rectangles.vue?vue&type=script&lang=js"
export * from "./rectangles.vue?vue&type=script&lang=js"
import style0 from "./rectangles.vue?vue&type=style&index=0&id=7c12b098&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports